import axios from "axios";
import { __constants } from "../constants";
import { createQuery } from "../utils";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getChatUsers = async (query) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/chat/users?limit=" + __constants.listingLimit + "&" + createQuery(query),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getChatInfo = async (conversationId,query) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/chat/logs/" + conversationId + "?limit=" + __constants.listingLimit + "&" + createQuery(query),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}